var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex border-b border-solid border-gray-200 py-3 bi-avoid"},[_c('span',{staticClass:"font-normal text-left text-gray-700"},[_vm._t("label")],2),_c('span',{staticClass:"ml-auto font-spacegrotesk-bold text-right"},[_vm._t("value")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }